import { useQuery } from '@tanstack/react-query';

import { listProperties } from '~/services/AccommodationService';

type AccommodationPropertiesQuery = Parameters<typeof listProperties>[0];

export const accommodationPropertiesQueryKeys = {
  all: ['accommodation', 'properties'] as const,
  lists: () => [...accommodationPropertiesQueryKeys.all, 'list'] as const,
  list: (filters: AccommodationPropertiesQuery) => [...accommodationPropertiesQueryKeys.lists(), filters] as const,
};

export function useGetAccommodationProperties(params: AccommodationPropertiesQuery) {
  return useQuery({
    queryKey: accommodationPropertiesQueryKeys.list(params),
    queryFn: async () => {
      const response = await listProperties(params);
      return response.result;
    },
  });
}
